import {
  CurrencyCourse,
  CurrencyDayCourseResponse,
} from '@/core/interfaces/exchange'

export function transformStatsToArray(
  statsData: CurrencyDayCourseResponse,
): CurrencyCourse[] {
  return Object.entries(statsData.stats).map(([fiat, currencies]) => ({
    code: fiat, // USD, EUR
    items: Object.values(currencies), // массив валют
  }))
}
